var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "input-group" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.filterText,
          expression: "filterText"
        }
      ],
      staticClass: "form-control",
      attrs: { type: "text", placeholder: _vm.placeholder },
      domProps: { value: _vm.filterText },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.doFilter.apply(null, arguments)
        },
        input: function($event) {
          if ($event.target.composing) return
          _vm.filterText = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "submit", title: _vm.buttonToolTip },
          on: { click: _vm.doFilter }
        },
        [_c("i", { staticClass: "fas fa-search fa-sm" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }